<template>
  <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col">
    <div class="board">
      <div class="logo-wrapper">
        <div class="logo" style="font-size: 14px">Diseño</div>
      </div>
      <br />
      <div class="border bg-light">
        <h5 class="text-center text-dark fs-6 text-uppercase p-3">
          Diseño del formulario de inscripción
        </h5>
      </div>
      <br />
      <label for="form-control"
        ><strong>Ingrese el nombre del formulario</strong></label
      >
      <!-- <el-divider>Ingrese el nombre del formulario</el-divider> -->

      <br />
      <input
        type="text"
        class="form-control text-uppercase"
        placeholder="Nombre del formulario"
        v-model="form_name"
      />
      <br />
      <label for="form-control"
        ><strong>Ingrese una descripción del formulario</strong></label
      >
      <br />
      <input
        type="text"
        class="form-control text-uppercase"
        placeholder="Descripción del formulario"
        v-model="form_description"
      />
      <br />
      <label for="form-control">Seleccione el tipo de formulario</label>
      <br />
      <select name="form_type" class="form-select" v-model="selectedFormType">
        <option value="" disabled selected>
          Seleccione el tipo de formulario
        </option>
        <option value="general">Población en General</option>
        <option value="students">Solo Estudiantes</option>
        <option value="teachers">Solo Maestros</option>
      </select>

      <br />

      <div v-if="selectedFormType">
        <button
          class="btn btn-outline-secondary w-100"
          @click="openFormInNewTab"
        >
          Ver el formulario base
        </button>
      </div>

      <br />
      <label for="form-control"
        ><strong> Datos adicionales a incorporar al fomulario</strong>
      </label>
      <div class="btn-group w-100">
        <div
          class="btn btn-outline-success w-50"
          @click="execDownload('test.vue')"
        >
          <el-icon> <video-play /> </el-icon>
          Registrar
        </div>
        <div class="btn btn-outline-danger w-50" @click="clearn()">
          <el-icon>
            <delete />
          </el-icon>
          Limpiar
        </div>
      </div>
      <br />
      <br />
      <el-scrollbar class="center-scrollbar" :class="[device, preview]">
        <page-drawer
          :model-value="settings"
          @update:model-value="update"
        ></page-drawer>
      </el-scrollbar>
    </div>
  </div>
  <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col">
    <page-setting
      :model-value="settings"
      @update:model-value="update"
    ></page-setting>
  </div>
  <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 col">
    <div class="board">
      <div class="logo-wrapper">
        <div class="logo" style="font-size: 14px">Parámetros</div>
      </div>
      <br />
      <div class="border bg-light">
        <h4 class="text-center text-dark fs-6 text-uppercase p-1">
          Parámetros adicionales para el formulario de inscripción
        </h4>
      </div>
      <br />
      <label for="form-control"
        >Seleccione el tipo de campo a adicionar al formulario</label
      >
      <el-scrollbar class="left-scrollbar">
        <page-panel
          @addComponent="
            (el) => {
              settings.drawingList.push(el);
            }
          "
        ></page-panel>

        <div class="components-list"></div>
      </el-scrollbar>
    </div>
  </div>

  <el-drawer v-model="showCode" direction="rtl" size="50%" style="height: 100%">
    <template v-slot:title>
      <div class="preview-action-bar">
        <div class="btn" @click="execDownload('test.vue')">
          <el-icon>
            <download /> </el-icon
          >Descargar
        </div>

        <div class="btn" @click="ClipboardWrite()">
          <el-icon> <document-copy /> </el-icon>Copiar
        </div>
      </div>
    </template>
    <el-scrollbar height="600px" v-highlight>
      <pre>
    <code> {{ generate(settings) }}</code>
  </pre>
    </el-scrollbar>
  </el-drawer>
</template>

<script>
import axios from "@/includes/connection";
import { inject, onMounted } from "vue";
import PageDrawer from "@/form_builder/components/form/PageDrawer.vue";
import PagePanel from "@/form_builder/components/form/PagePanel.vue";
import PageSetting from "@/form_builder/components/form/PageSetting.vue";
import useClipboard from "vue-clipboard3";

import { ElMessage } from "element-plus";

import { saveAs } from "file-saver";

import {
  deepClone,
  findEle,
  isObjectArray,
  randFieldId,
} from "@/form_builder/utils/func.js";
import { formConf } from "@/form_builder/components/form/ui/index";
import { generate, generateJSON } from "@/form_builder/utils/generate.js";
import {
  Iphone,
  Monitor,
  VideoPlay,
  Delete,
  Download,
  DocumentCopy,
} from "@element-plus/icons-vue";
import { defineComponent, provide, reactive, ref, watch, computed } from "vue";

export default defineComponent({
  name: "PageGenerator",
  props: {},
  components: {
    PagePanel,
    PageSetting,
    PageDrawer,
    DocumentCopy,
    Iphone,
    Monitor,
    VideoPlay,
    Delete,
    Download,
  },

  emits: ["reloadList"],

  setup(props, ctx) {
    const swal = inject("$swal");
    const form_name = ref("");
    const device = ref("pc");
    const showCode = ref(false);
    const preview = ref("");
    const form_description = ref("");
    const orienteds = ref([]);
    const selectedFormType = ref("");

    function openFormInNewTab() {
      const url = `/form-preview?form_type=${selectedFormType.value}`;
      window.open(url, "_blank");
    }

    const formTypeToOrientation = {
      general: 1,
      students: 2,
      teachers: 3,
    };

    const oriented_id = computed(() => {
      return formTypeToOrientation[selectedFormType.value] || null;
    });

    // const emit = ["reloadList"]

    const loadSetting = function () {
      let strs = localStorage.getItem("settings");
      if (strs) {
        return JSON.parse(strs);
      }

      return {
        current: "",
        formConf: formConf,
        drawingList: [],
      };
    };

    const settings = reactive(loadSetting());

    const loadOriented = function () {
      console.log("Obteniendo oriented");
      axios
        .get("kind-event/oriented")
        .then((response) => {
          if (response.data) {
            orienteds.value = response.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    onMounted(() => {
      loadOriented();
    });

    const update = function (e) {
      console.log("update element", e);
      settings.formConf = e.formConf;
      settings.drawingList = e.drawingList;
    };

    const selected = function (s) {
      settings.current = s;
    };

    const clearn = function () {
      localStorage.removeItem("settings");

      settings.current = "";
      settings.formConf = formConf;
      settings.drawingList = [];
    };

    /**
     * 选中高亮亮
     */
    const hightLight = function (s) {
      if (settings.current == s) {
        return { border: "1px solid #ffc92fde", backgroundColor: "#e4ff0024" };
      }
      return {};
    };

    const _del = function (items, _id) {
      for (let item of items) {
        if (item.__ID == _id) {
          items.splice(items.indexOf(item), 1);
          return true;
        } else if (isObjectArray(item.childrens)) {
          if (_del(item.childrens, _id)) {
            return true;
          }
        }
      }
    };

    const deleteItem = function (_id) {
      _del(settings.drawingList, _id);
    };

    const _copy = function (items, _id) {
      for (let item of items) {
        if (item.__ID == _id) {
          const newItem = deepClone(item);
          newItem.__ID = randFieldId();
          items.push(reactive(newItem));
          return true;
        } else if (isObjectArray(item.childrens)) {
          if (_copy(item.childrens, _id)) {
            return true;
          }
        }
      }
    };

    const copyItem = function (_id) {
      _copy(settings.drawingList, _id);
    };

    const updateChild = function (eles, ids) {
      let item = findEle(settings.drawingList, ids);

      item.childrens = eles;
    };

    const updateDefaultValue = function (val, ids) {
      let item = findEle(settings.drawingList, ids);

      item.defaultvalue = val;
    };

    const toVal = function (obj) {
      const _c = {};
      for (let a in obj) {
        if (typeof obj[a] == "object") {
          if ("__val__" in obj[a]) {
            _c[a] = obj[a]["__val__"];
          } else {
            _c[a] = toVal(obj[a]);
          }
        } else {
          _c[a] = obj[a];
        }
      }

      return _c;
    };

    const execDownload = function (filename) {
      //---Init transform

      const selout = generateJSON(settings);
      const listItems = selout.childrens;

      let itemPersist = [];

      Object.entries(listItems).filter((el) => {
        let my_child = [];
        if (el[1].hasOwnProperty("childrens")) {
          //console.log("input con childres");
          //console.log("input", JSON.stringify(el[1], null, 2));

          //usamos datos del __opt__.staticdata
          if (el[1].__opt__ && el[1].__opt__.staticData) {
            //console.log("usando staticdata");
            //console.log("staticdata:", el[1].__opt__.staticData);

            my_child = el[1].__opt__.staticData.map((option) => ({
              key: option.key,
              value: option.value,
            }));

            //console.log("el children con static data", my_child);
          } else {
            console.log("usando slots.default");
            Object.entries(el[1].childrens).filter((child, idx) => {
              //console.log(`child ${idx}`);
              //console.log("child structura", JSON.stringify(child, null, 2));

              let key = child[1].slots?.default || `Opción ${idx + 1}`;
              let value = child[1].attrs?.label || idx + 1;

              let new_child = {
                key: key,
                value: value,
              };

              //console.log("new child creado", new_child);
              my_child.push(new_child);
            });
          }
        }

        let isRequired = false;
        if (
          settings.formConf.__rules &&
          el[1].attrs &&
          el[1].attrs.fieldName &&
          settings.formConf.__rules[el[1].attrs.fieldName.__val__]
        ) {
          const rulesArr =
            settings.formConf.__rules[el[1].attrs.fieldName.__val__];
          isRequired =
            Array.isArray(rulesArr) &&
            rulesArr.some((r) => r.required === true);
        }

        let my_element = {
          label: el[1].formItem.label,
          name: el[1].attrs.fieldName,
          as: el[1].tagIcon,
          type: el[1].attrs?.type,
          children: my_child,
          required: isRequired,
          ...el[1].attrs,
        };

        itemPersist.push(my_element);
        //console.log("my_element", JSON.stringify(my_element, null, 2));
      });

      //console.log("resultado");
      //console.log("itempersist:", JSON.stringify(itemPersist, null, 2));

      if (form_name.value.length == 0) {
        swal.fire("Se requiere el nombre del formulario", "", "info");
        return;
      }

      if (form_description.value.length == 0) {
        swal.fire("Se requiere la descripción del formulario", "", "info");
        return;
      }

      if (!selectedFormType.value) {
        swal.fire("Debe seleccionar un tipo de formulario", "", "info");
        return;
      }

      if (!localStorage.getItem("User")) {
        console.log("error", "No hay usuario logueado");
        return;
      }

      const user = JSON.parse(localStorage.getItem("User"));
      const request = {
        html: JSON.stringify(itemPersist),
        detail: form_name.value,
        description: form_description.value,
        oriented_id: oriented_id.value,
        user_id: user.id,
      };

      axios
        .post("/enrollment-form", request)
        .then((response) => {
          swal.fire({
            title: "Registro Exitoso!!!",
            icon: "success",
          });
          ctx.emit("reloadList");
          form_name.value = "";
          form_description.value = "";
          selectedFormType.value = "";
          clearn();
        })
        .catch(function (error) {
          console.log("error", error);
          swal.fire({
            title: "Registro fallido!!!",
            icon: "warning",
          });
        });
    };

    const preViewCode = function () {
      showCode.value = true;
    };

    const { toClipboard } = useClipboard();

    const ClipboardWrite = async () => {
      const codeStr = generate(settings);
      try {
        await toClipboard(codeStr);
        ElMessage("Acción Exitosa");
        console.log("Copied to clipboard");
      } catch (e) {
        console.error(e);
      }
    };

    watch(settings, () => {
      console.log(settings);
      localStorage.setItem("settings", JSON.stringify(settings));
    });

    provide("copyItem", copyItem);
    provide("deleteItem", deleteItem);
    provide("selected", selected);
    provide("updateChild", updateChild);
    provide("hightLight", hightLight);
    provide("updateDefaultValue", updateDefaultValue);
    return {
      settings,
      update,
      device,
      clearn,
      preview,
      generate,
      generateJSON,
      execDownload,
      showCode,
      preViewCode,
      ClipboardWrite,
      form_name,
      selectedFormType,
      oriented_id,
      form_description,
      openFormInNewTab,
    };
  },
});
</script>

<style lang="scss">
@import "@/form_builder/styles/home";
@import "@/form_builder/styles/index";
</style>
